
module Meevo.Plugins.BusinessInfo {

    export class ServiceCategoryDisplayOrderSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public serviceCategories: any
        public addedServiceCategories: any;
        public servicePriorityModel: any;
        public securityKeyDelete: any;
        public selectedCategory: any;
        public isAddingCategory = false;
        public allCategories: any;
        public isLoadingCategories = false;
        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $translate: angular.translate.ITranslateService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.securityKeyDelete = sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;

        }

        activate(): any {
            this.addedServiceCategories = (this.model) as Model.ServiceCategoryPriority;
            this.loadAllCategories();
            super.activate();
        }

        loadAllCategories = () => {
            if (this.isLoadingCategories) {
                return;
            }
            const MAXSAFEINTEGER = 2147483647;
            this.isLoadingCategories = true;
            let request = {
                criteria: this.getTypeaheadCriteria(),
                itemsPerPage: MAXSAFEINTEGER,
                pageNumber: 0,
                sortBy: null,
                sortDirection: 0
            };
            this.dataService.getListPaged("servicecategory", request).then((data: any) => {
                this.allCategories = data || [];
            }).finally(() => {
                this.isLoadingCategories = false;
            });
        }

        hasAvailableCategories = () => {
            if (Model.Guard.isNothing(this.allCategories)) {
                return false;
            }
            if (Model.Guard.isNothing(this.model) || Model.Guard.isNothing(this.model.serviceCategoryList)) {
                return this.allCategories.length > 0;
            }
            return _.some(this.allCategories,
                (item: any) => !_.some(this.model.serviceCategoryList, (added: any) => added.id === item.id));
        }

        preSave() {
            _.forEach(this.model.serviceCategoryList,
                (category: any) => {
                    this.initializeSubCategories(category);
                    category.subCategories = category.displayedSubCategories;
                    _.forEach(category.subCategories,
                        (subCat: any) => {
                            this.initializeServices(subCat);
                            subCat.services = subCat.displayedServices;
                        });
                });
            super.preSave();
        }

        initializeSubCategories = (category: any) => {
            if (Model.Guard.isSomething(category.allSubCategories)) {
                return;
            }
            category.allSubCategories = category.subCategories || [];
            if (category.allSubCategories.length === 1) {
                category.displayedSubCategories = category.allSubCategories.slice();
            } else {
                category.displayedSubCategories = _.filter(category.allSubCategories,
                    (subCat: any) => Model.Guard.isSomething(subCat.displayPosition));
            }
        }

        getDisplayedSubCategories = (category: any) => {
            this.initializeSubCategories(category);
            return category.displayedSubCategories;
        }

        hasMultipleSubCategories = (category: any) => {
            this.initializeSubCategories(category);
            return category.allSubCategories.length > 1;
        }

        hasSubCategorySection = (category: any, isReadonly?: boolean) => {
            return this.getDisplayedSubCategories(category).length > 0 || this.hasMultipleSubCategories(category);
        }

        startAddingSubCategory = (category: any) => {
            this.initializeSubCategories(category);
            category.selectedSubCategory = "";
            category.isAddingSubCategory = true;
        }

        getSubCategoryTypeaheadCriteria = (category: any): any => {
            let criteria: any = this.getTypeaheadCriteria();
            criteria.catId = category.id;
            return criteria;
        }

        filterAvailableSubCategories = (response: any, category: any) => {
            if (Model.Guard.isNothing(response) || Model.Guard.isNothing(category)) {
                return;
            }
            this.initializeSubCategories(category);
            for (var i = response.length - 1; i >= 0; i--) {
                if (_.some(category.displayedSubCategories, (item: any) => item.id === response[i].id)) {
                    response.splice(i, 1);
                }
            }
        }

        addSubCategory = (category: any) => {
            let selected = category.selectedSubCategory;
            if (selected == "" || Model.Guard.isNothing(selected)) {
                return;
            }
            this.initializeSubCategories(category);
            if (_.some(category.displayedSubCategories, (item: any) => item.id === selected.id)) {
                return;
            }
            let existing = _.find(category.allSubCategories, (item: any) => item.id === selected.id);
            let added = existing || selected;
            category.displayedSubCategories.push(added);
            category.selectedSubCategory = "";
            this.ensureServices(added);
        }

        confirmRemoval = (item: any): angular.IPromise<boolean> => {
            let message = this.$translate.instant("MESSAGE_REMOVE_DISPLAY_ORDER_ITEM_CONFIRMATION",
                { displayName: item.displayName });
            return this.modalService.confirmHandler(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        removeSubCategory = (category: any, subCat: any) => {
            if (!this.hasDisplayedServices(subCat)) {
                this.removeSubCategoryFromDisplay(category, subCat);
                return;
            }
            this.confirmRemoval(subCat).then((confirmed: boolean) => {
                if (confirmed) {
                    this.removeSubCategoryFromDisplay(category, subCat);
                }
            });
        }

        private removeSubCategoryFromDisplay = (category: any, subCat: any) => {
            let index = _.findIndex(category.displayedSubCategories, (item: any) => item.id === subCat.id);
            if (index >= 0) {
                category.displayedSubCategories.splice(index, 1);
            }
            this.initializeServices(subCat);
            subCat.displayedServices = subCat.allServices.length === 1 ? subCat.allServices.slice() : [];
        }

        hasAnyExpandable = (isReadonly?: boolean) => {
            if (Model.Guard.isNothing(this.model) || Model.Guard.isNothing(this.model.serviceCategoryList)) {
                return false;
            }
            return _.some(this.model.serviceCategoryList, (category: any) => {
                if (this.hasSubCategorySection(category, isReadonly)) {
                    return true;
                }
                return _.some(this.getDisplayedSubCategories(category),
                    (subCat: any) => this.hasMultipleServices(subCat));
            });
        }

        isAllExpanded = (isReadonly?: boolean) => {
            if (!this.hasAnyExpandable(isReadonly)) {
                return false;
            }
            return _.every(this.model.serviceCategoryList, (category: any) => {
                if (this.hasSubCategorySection(category, isReadonly) && !category.isExpanded) {
                    return false;
                }
                return _.every(this.getDisplayedSubCategories(category),
                    (subCat: any) => !this.hasMultipleServices(subCat) || subCat.isServicesExpanded === true);
            });
        }

        setAllExpanded = (expanded: boolean, isReadonly?: boolean) => {
            _.forEach(this.model.serviceCategoryList, (category: any) => {
                if (this.hasSubCategorySection(category, isReadonly)) {
                    category.isExpanded = expanded;
                }
                _.forEach(this.getDisplayedSubCategories(category), (subCat: any) => {
                    if (this.hasMultipleServices(subCat)) {
                        subCat.isServicesExpanded = expanded;
                    }
                });
            });
        }

        toggleExpandAll = (isReadonly?: boolean) => {
            this.setAllExpanded(!this.isAllExpanded(isReadonly), isReadonly);
        }

        toggleServices = (subCat: any) => {
            subCat.isServicesExpanded = !subCat.isServicesExpanded;
            if (subCat.isServicesExpanded) {
                this.ensureServices(subCat);
            }
        }

        ensureServices = (subCat: any) => {
            if (Model.Guard.isSomething(subCat.services) || subCat.isLoadingServices) {
                return;
            }
            const MAXSAFEINTEGER = 2147483647;
            subCat.isLoadingServices = true;
            let request = {
                criteria: this.getServiceTypeaheadCriteria(subCat),
                itemsPerPage: MAXSAFEINTEGER,
                pageNumber: 0,
                sortBy: null,
                sortDirection: 0
            };
            this.dataService.getListPaged("service", request).then((data: any) => {
                subCat.services = data || [];
                delete subCat.allServices;
                delete subCat.displayedServices;
                this.initializeServices(subCat);
            }).finally(() => {
                subCat.isLoadingServices = false;
            });
        }

        initializeServices = (subCat: any) => {
            if (Model.Guard.isSomething(subCat.allServices)) {
                return;
            }
            subCat.allServices = subCat.services || [];
            if (subCat.allServices.length === 1) {
                subCat.displayedServices = subCat.allServices.slice();
            } else {
                subCat.displayedServices = _.filter(subCat.allServices,
                    (service: any) => Model.Guard.isSomething(service.catSubDisplayPosition));
            }
        }

        getDisplayedServices = (subCat: any) => {
            this.initializeServices(subCat);
            return subCat.displayedServices;
        }

        hasMultipleServices = (subCat: any) => {
            this.initializeServices(subCat);
            return subCat.allServices.length > 1;
        }

        hasDisplayedServices = (subCat: any) => {
            return this.getDisplayedServices(subCat).length > 0;
        }

        hasServiceSection = (subCat: any) => {
            return this.getDisplayedServices(subCat).length > 0 || this.hasMultipleServices(subCat);
        }

        isServicesVisible = (subCat: any) => {
            if (!this.hasServiceSection(subCat)) {
                return false;
            }
            if (!this.hasMultipleServices(subCat)) {
                return true;
            }
            return subCat.isServicesExpanded === true;
        }

        startAddingService = (subCat: any) => {
            this.initializeServices(subCat);
            subCat.selectedService = "";
            subCat.isAddingService = true;
        }

        getServiceTypeaheadCriteria = (subCat: any): any => {
            return { serviceSubCategoryId: subCat.id };
        }

        filterAvailableServices = (response: any, subCat: any) => {
            if (Model.Guard.isNothing(response) || Model.Guard.isNothing(subCat)) {
                return;
            }
            this.initializeServices(subCat);
            for (var i = response.length - 1; i >= 0; i--) {
                if (_.some(subCat.displayedServices, (item: any) => item.id === response[i].id)) {
                    response.splice(i, 1);
                }
            }
        }

        addService = (subCat: any) => {
            let selected = subCat.selectedService;
            if (selected == "" || Model.Guard.isNothing(selected)) {
                return;
            }
            this.initializeServices(subCat);
            if (_.some(subCat.displayedServices, (item: any) => item.id === selected.id)) {
                return;
            }
            let existing = _.find(subCat.allServices, (item: any) => item.id === selected.id);
            subCat.displayedServices.push(existing || selected);
            subCat.selectedService = "";
        }

        removeService = (subCat: any, service: any) => {
            let index = _.findIndex(subCat.displayedServices, (item: any) => item.id === service.id);
            if (index >= 0) {
                subCat.displayedServices.splice(index, 1);
            }
        }

        getTypeaheadCriteria(): any {
            let criteria: any = {};
            if (this.identityService.inCentralOfficeMode()) {
                criteria.coFilterByLocationId = this.identityService.locationId;
                criteria.coSearchType = Model.CoSearchType.CentralOffice;
            } else {
                criteria.coFilterByLocationId = this.identityService.locationId;
                criteria.coSearchType = Model.CoSearchType.Location;
                criteria.coSearchResultFilter = Model.CoSearchResultsFilter.LocationOwned;
            }
            return criteria;
        }

        getServiceCategory(item: any, alreadyExists: any): any {

            var subCategories: any = "";
            if ((item.isPrioritizeSubCategories || !alreadyExists) && Model.Guard.isNothing(item.subCategories))
                subCategories = this.dataService.customMethodData("/api/ServiceCategory/" + item.id, 'Get', this.getTypeaheadCriteria())
                    .then((response) => {
                        if (Model.Guard.isSomething(response.data))
                            return response.data.subCategories;
                    });


            return subCategories;
        }

        addCategory = (category) => {
            if (category == "" || Model.Guard.isNothing(category)) {
                return;
            }
            let alreadyExists = false;
            _.find(this.model.serviceCategoryList,
                function (item: any) {
                    if (item.displayName == category.displayName) {
                        alreadyExists = true;
                        return alreadyExists;
                    } else {
                        return false;
                    }
                });
            if (!alreadyExists) {
                this.getServiceCategory(category, alreadyExists).then((response) => {
                    category.subCategories = response || [];
                    category.homeLocationId = category.ownedByLocationId;
                    this.initializeSubCategories(category);
                    _.forEach(category.displayedSubCategories, (subCat: any) => this.ensureServices(subCat));
                    this.model.serviceCategoryList.push(category);
                    this.selectedCategory = "";
                });
            }
        }

        removeCategory = (category) => {
            this.confirmRemoval(category).then((confirmed: boolean) => {
                if (!confirmed) {
                    return;
                }
                let index = _.findIndex(this.model.serviceCategoryList, function (item: any) {
                    if (category.id == item.id) {
                        return true
                    }
                    else {
                        return false
                    }
                });
                this.model.serviceCategoryList.splice(index, 1);
            });
        }

        hasEditPermision = (item) => {
            var locationId: any;
            if (this.identityService.isSingleLocation()) 
            {
                return true;
            } 
            if (Model.Guard.isSomething(item.ownedByLocationId))
                locationId = item.ownedByLocationId;
            else {
                locationId = item.homeLocationId;
            }            
            return locationId == this.identityService.locationId;
        }

        switch = (index1: number, index2: number, array: any, parentIndex?: number) => {
            if (parentIndex != null) {
                array = this.model.serviceCategoryList[parentIndex].displayedSubCategories;
            } else {
                array = this.model.serviceCategoryList;
            }
            if (array[index1] && array[index2]) {
                var temp = array[index2];
                array[index2] = array[index1];
                array[index1] = temp;
            }
        }

        switchService = (index1: number, index2: number, catIndex: number, subCatIndex: number) => {
            let category = this.model.serviceCategoryList[catIndex];
            if (Model.Guard.isNothing(category)) {
                return;
            }
            let subCat = category.displayedSubCategories[subCatIndex];
            if (Model.Guard.isNothing(subCat)) {
                return;
            }
            let array = subCat.displayedServices;
            if (array[index1] && array[index2]) {
                var temp = array[index2];
                array[index2] = array[index1];
                array[index1] = temp;
            }
        }
    }
}
